import { Routes, Route } from 'react-router-dom'
import '@aws-amplify/ui-react/styles.css'

// Layout Components
import Navbar from '@components/Navbar/Navbar'
import Footer from '@components/Footer/Footer'

// Public Pages
import Home from '@pages/Home/Home'
import Services from '@pages/Services/Services'
import Contact from '@pages/Contact/Contact'
import Login from '@pages/Auth/Login'

// Protected Pages
import Dashboard from '@pages/Dashboard/Dashboard'
import ComparadorDIAN from '@pages/Tools/ComparadorDIAN'
import ConciliacionBancaria from '@pages/Tools/ConciliacionBancaria'
import CalendarioTributario from '@pages/CalendarioTributario/CalendarioTributario'
import TableroFinanciero from '@pages/TableroFinanciero/TableroFinanciero'
import Comisiones from '@pages/Comisiones/Comisiones'
import CuentaCompensacion from '@pages/CuentaCompensacion/CuentaCompensacion'
import MundoDigital from '@pages/MundoDigital/MundoDigital'
import ServerUsageManager from '@pages/Admin/ServerUsageManager'

// Admin Panel (Solo SuperAdmins)
import AdminPanel from '@pages/Admin/AdminPanel'

// Route Wrappers
import ProtectedRoute from '@components/Auth/ProtectedRoute'
import ModuleRoute from '@components/Auth/ModuleRoute'

function App() {
    return (
        <div className="app">
            <Navbar />

            <main className="main-content">
                <Routes>
                    {/* Public Routes */}
                    <Route path="/" element={<Home />} />
                    <Route path="/servicios" element={<Services />} />
                    <Route path="/contacto" element={<Contact />} />
                    <Route path="/login" element={<Login />} />

                    {/* Dashboard (cualquier usuario autenticado) */}
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    />

                    {/* Panel SuperAdmin */}
                    <Route
                        path="/admin/*"
                        element={<AdminPanel />}
                    />

                    {/* Herramientas — protegidas por módulo */}
                    <Route
                        path="/herramientas/comparador-dian"
                        element={
                            <ModuleRoute moduleKey="comparador_dian">
                                <ComparadorDIAN />
                            </ModuleRoute>
                        }
                    />
                    <Route
                        path="/herramientas/conciliacion-bancaria"
                        element={
                            <ModuleRoute moduleKey="conciliacion_bancaria">
                                <ConciliacionBancaria />
                            </ModuleRoute>
                        }
                    />
                    <Route
                        path="/herramientas/calendario-tributario"
                        element={
                            <ModuleRoute moduleKey="calendario_tributario">
                                <CalendarioTributario />
                            </ModuleRoute>
                        }
                    />
                    <Route
                        path="/herramientas/tablero-financiero"
                        element={
                            <ModuleRoute moduleKey="tablero_financiero">
                                <TableroFinanciero />
                            </ModuleRoute>
                        }
                    />
                    <Route
                        path="/herramientas/comisiones"
                        element={
                            <ModuleRoute moduleKey="comisiones">
                                <Comisiones />
                            </ModuleRoute>
                        }
                    />
                    <Route
                        path="/herramientas/cuenta-compensacion"
                        element={
                            <ModuleRoute moduleKey="cuenta_compensacion">
                                <CuentaCompensacion />
                            </ModuleRoute>
                        }
                    />
                    <Route
                        path="/mundo-digital"
                        element={
                            <ModuleRoute moduleKey="mundo_digital">
                                <MundoDigital />
                            </ModuleRoute>
                        }
                    />
                    <Route
                        path="/herramientas/uso-servidores"
                        element={
                            <ModuleRoute moduleKey="uso_servidores">
                                <ServerUsageManager />
                            </ModuleRoute>
                        }
                    />
                </Routes>
            </main>

            <Footer />
        </div>
    )
}

export default App
